import { Button } from "@mui/material";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header";
import Middle from "./components/Middle";
import Bottom from "./components/Bottom";

const AppStyles = styled("div")({
  display: "flex",
  flexDirection: "column",
  height: "100vh",  // Take up the full viewport height
});


const App = () => {
  return (
    <AppStyles>
      <Header></Header>
      <Middle></Middle>
      <Bottom></Bottom>
    </AppStyles>
  );
};

export default App;
